import { parseMentions } from '~/utils/mention-helpers';

type MessageContentProps = {
  text: string;
  className?: string;
  /** Slack-style @mention chips */
  variant?: 'default' | 'slack';
};

export function MessageContent({ text, className, variant = 'default' }: MessageContentProps) {
  const fragments = parseMentions(text);
  const bodyClass =
    className ??
    (variant === 'slack'
      ? 'text-[15px] text-gray-900 leading-[1.466] whitespace-pre-wrap break-words'
      : 'text-sm text-gray-800 leading-relaxed whitespace-pre-line');

  return (
    <p className={bodyClass}>
      {fragments.map((f, i) =>
        f.type === 'mention' ? (
          <span
            key={i}
            className={
              variant === 'slack' ? 'text-sky-900 font-medium' : 'text-purple-600 font-medium'
            }
          >
            @{f.displayName}
          </span>
        ) : (
          <span key={i}>{f.content}</span>
        )
      )}
    </p>
  );
}
